<ng-container *ngIf="currentBaseStore$ | async as currentBaseStore">
  <span (click)="openModal()"
    >
    {{ "shipping.headerText.destiny" | cxTranslate }} : {{ currentBaseStore.name }}
  </span>
</ng-container>
